// @ts-nocheck
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import { postSubmitWarrantyForm } from "@store/Framework/Services/Components/WarrantyForm/WarrantyFormService";

type SubmitContactFormParameter = {} & HasOnSuccess;

export interface SubmitWarrantyFormApiParameter extends ApiParameter {
    BaseUnitInstallDate: string;
    SignedName: string;
    BaseUnitModelNumber: string;
    BaseUnitSerialNumber: string;
    ClientEmail: string;
    CompanyCity: string;
    CompanyName: string;
    CompanyPhone: string;
    CompanySt: string;
    CompanyStreet: string;
    CompanyZip: string;
    DcneAccountNumber: string;
    DiagnosisBulletinNumber: string;
    FailDate: string;
    JobSiteName: string;
    JobSiteStreet: string;
    JobSiteCity: string;
    JobSiteSt: string;
    JobSiteZip: string;
    JobSitePhone: string;
    ReasonForRepairFailure: string;
    RepairCompleteDate: string;
    ReplacementDcneInvoiceNumber: string;
    ReplacementPartWarrantyDate?: string;
    ReplacementPartWarrantyInvoiceNumber?: string;
    SubmittedFormDate: string;
    FailedPartNumber1: string;
    FailedPartNumber2?: string;
    FailedPartNumber3?: string;
    FailedPartNumber4?: string;
    FailedPartNumber5?: string;
    FailedPartNumber6?: string;
    FailedPartNumber7?: string;
    FailedPartNumber8?: string;
    FailedPartNumber9?: string;
    FailedPartNumber10?: string;
    FailedQty1: string;
    FailedQty2?: string;
    FailedQty3?: string;
    FailedQty4?: string;
    FailedQty5?: string;
    FailedQty6?: string;
    FailedQty7?: string;
    FailedQty8?: string;
    FailedQty9?: string;
    FailedQty10?: string;
    FailedSerialNumber1: string;
    FailedSerialNumber2?: string;
    FailedSerialNumber3?: string;
    FailedSerialNumber4?: string;
    FailedSerialNumber5?: string;
    FailedSerialNumber6?: string;
    FailedSerialNumber7?: string;
    FailedSerialNumber8?: string;
    FailedSerialNumber9?: string;
    FailedSerialNumber10?: string;
    FailedReplacementPartNumber1: string;
    FailedReplacementPartNumber2?: string;
    FailedReplacementPartNumber3?: string;
    FailedReplacementPartNumber4?: string;
    FailedReplacementPartNumber5?: string;
    FailedReplacementPartNumber6?: string;
    FailedReplacementPartNumber7?: string;
    FailedReplacementPartNumber8?: string;
    FailedReplacementPartNumber9?: string;
    FailedReplacementPartNumber10?: string;
    FailedReplacementSerialNumber1: string;
    FailedReplacementSerialNumber2?: string;
    FailedReplacementSerialNumber3?: string;
    FailedReplacementSerialNumber4?: string;
    FailedReplacementSerialNumber5?: string;
    FailedReplacementSerialNumber6?: string;
    FailedReplacementSerialNumber7?: string;
    FailedReplacementSerialNumber8?: string;
    FailedReplacementSerialNumber9?: string;
    FailedReplacementSerialNumber10?: string;
    FailedReplacementQty1: string;
    FailedReplacementQty2?: string;
    FailedReplacementQty3?: string;
    FailedReplacementQty4?: string;
    FailedReplacementQty5?: string;
    FailedReplacementQty6?: string;
    FailedReplacementQty7?: string;
    FailedReplacementQty8?: string;
    FailedReplacementQty9?: string;
    FailedReplacementQty10?: string;
    SelectedWarrantyType: string;
}

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitWarrantyFormApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().store.components.warrantyForm;
    props.apiParameter = {
        BaseUnitInstallDate: state.fieldValues["baseUnitInstallDate"]!,
        SignedName: state.fieldValues["signedName"]!,
        BaseUnitModelNumber: state.fieldValues["baseUnitModelNumber"]!,
        BaseUnitSerialNumber: state.fieldValues["baseUnitSerialNumber"]!,
        ClientEmail: state.fieldValues["clientEmail"]!,
        CompanyName: state.fieldValues["companyName"]!,
        CompanyPhone: state.fieldValues["companyPhone"]!,
        CompanyCity: state.fieldValues["companyCity"]!,
        CompanySt: state.fieldValues["companySt"]!,
        CompanyStreet: state.fieldValues["companyStreet"]!,
        CompanyZip: state.fieldValues["companyZip"]!,
        DcneAccountNumber: state.fieldValues["dcneAccountNumber"]!,
        DiagnosisBulletinNumber: state.fieldValues["diagnosisBulletinNumber"]!,
        FailDate: state.fieldValues["failDate"]!,
        JobSiteName: state.fieldValues["jobSiteName"]!,
        JobSiteStreet: state.fieldValues["jobSiteStreet"]!,
        JobSiteCity: state.fieldValues["jobSiteCity"]!,
        JobSiteSt: state.fieldValues["jobSiteSt"]!,
        JobSiteZip: state.fieldValues["jobSiteZip"]!,
        JobSitePhone: state.fieldValues["jobSitePhone"]!,
        ReasonForRepairFailure: state.fieldValues["reasonForRepairFailure"]!,
        RepairCompleteDate: state.fieldValues["repairCompleteDate"]!,
        ReplacementDcneInvoiceNumber: state.fieldValues["replacementDcneInvoiceNumber"]!,
        SubmittedFormDate: state.fieldValues["submittedFormDate"]!,
        FailedPartNumber1: state.fieldValues["failedPartNumber1"]!,
        FailedPartNumber2: state.fieldValues["failedPartNumber2"],
        FailedPartNumber3: state.fieldValues["failedPartNumber3"],
        FailedPartNumber4: state.fieldValues["failedPartNumber4"],
        FailedPartNumber5: state.fieldValues["failedPartNumber5"],
        FailedPartNumber6: state.fieldValues["failedPartNumber6"],
        FailedPartNumber7: state.fieldValues["failedPartNumber7"],
        FailedPartNumber8: state.fieldValues["failedPartNumber8"],
        FailedPartNumber9: state.fieldValues["failedPartNumber9"],
        FailedPartNumber10: state.fieldValues["failedPartNumber10"],
        FailedQty1: state.fieldValues["failedQty1"]!,
        FailedQty2: state.fieldValues["failedQty2"],
        FailedQty3: state.fieldValues["failedQty3"],
        FailedQty4: state.fieldValues["failedQty4"],
        FailedQty5: state.fieldValues["failedQty5"],
        FailedQty6: state.fieldValues["failedQty6"],
        FailedQty7: state.fieldValues["failedQty7"],
        FailedQty8: state.fieldValues["failedQty8"],
        FailedQty9: state.fieldValues["failedQty9"],
        FailedQty10: state.fieldValues["failedQty10"],
        FailedSerialNumber1: state.fieldValues["failedSerialNumber1"]!,
        FailedSerialNumber2: state.fieldValues["failedSerialNumber2"],
        FailedSerialNumber3: state.fieldValues["failedSerialNumber3"],
        FailedSerialNumber4: state.fieldValues["failedSerialNumber4"],
        FailedSerialNumber5: state.fieldValues["failedSerialNumber5"],
        FailedSerialNumber6: state.fieldValues["failedSerialNumber6"],
        FailedSerialNumber7: state.fieldValues["failedSerialNumber7"],
        FailedSerialNumber8: state.fieldValues["failedSerialNumber8"],
        FailedSerialNumber9: state.fieldValues["failedSerialNumber9"],
        FailedSerialNumber10: state.fieldValues["failedSerialNumber10"],
        FailedReplacementPartNumber1: state.fieldValues["failedReplacementPartNumber1"]!,
        FailedReplacementPartNumber2: state.fieldValues["failedReplacementPartNumber2"],
        FailedReplacementPartNumber3: state.fieldValues["failedReplacementPartNumber3"],
        FailedReplacementPartNumber4: state.fieldValues["failedReplacementPartNumber4"],
        FailedReplacementPartNumber5: state.fieldValues["failedReplacementPartNumber5"],
        FailedReplacementPartNumber6: state.fieldValues["failedReplacementPartNumber6"],
        FailedReplacementPartNumber7: state.fieldValues["failedReplacementPartNumber7"],
        FailedReplacementPartNumber8: state.fieldValues["failedReplacementPartNumber8"],
        FailedReplacementPartNumber9: state.fieldValues["failedReplacementPartNumber9"],
        FailedReplacementPartNumber10: state.fieldValues["failedReplacementPartNumber10"],
        FailedReplacementSerialNumber1: state.fieldValues["failedReplacementSerialNumber1"]!,
        FailedReplacementSerialNumber2: state.fieldValues["failedReplacementSerialNumber2"],
        FailedReplacementSerialNumber3: state.fieldValues["failedReplacementSerialNumber3"],
        FailedReplacementSerialNumber4: state.fieldValues["failedReplacementSerialNumber4"],
        FailedReplacementSerialNumber5: state.fieldValues["failedReplacementSerialNumber5"],
        FailedReplacementSerialNumber6: state.fieldValues["failedReplacementSerialNumber6"],
        FailedReplacementSerialNumber7: state.fieldValues["failedReplacementSerialNumber7"],
        FailedReplacementSerialNumber8: state.fieldValues["failedReplacementSerialNumber8"],
        FailedReplacementSerialNumber9: state.fieldValues["failedReplacementSerialNumber9"],
        FailedReplacementSerialNumber10: state.fieldValues["failedReplacementSerialNumber10"],
        FailedReplacementQty1: state.fieldValues["failedReplacementQty1"]!,
        FailedReplacementQty2: state.fieldValues["failedReplacementQty2"],
        FailedReplacementQty3: state.fieldValues["failedReplacementQty3"],
        FailedReplacementQty4: state.fieldValues["failedReplacementQty4"],
        FailedReplacementQty5: state.fieldValues["failedReplacementQty5"],
        FailedReplacementQty6: state.fieldValues["failedReplacementQty6"],
        FailedReplacementQty7: state.fieldValues["failedReplacementQty7"],
        FailedReplacementQty8: state.fieldValues["failedReplacementQty8"],
        FailedReplacementQty9: state.fieldValues["failedReplacementQty9"],
        FailedReplacementQty10: state.fieldValues["failedReplacementQty10"],
        SelectedWarrantyType: state.fieldValues["selectedWarrantyType"]!,
    };
    if (state.fieldValues.selectedWarrantyType === "ReplacementPartWarranty") {
        if (state.fieldValues["replacementPartWarrantyDate"]) {
            props.apiParameter.ReplacementPartWarrantyDate = state.fieldValues["replacementPartWarrantyDate"];
        }
        if (state.fieldValues["replacementPartWarrantyInvoiceNumber"]) {
            props.apiParameter.ReplacementPartWarrantyInvoiceNumber =
                state.fieldValues["replacementPartWarrantyInvoiceNumber"];
        }
    }
};

export const SendDataToApi: HandlerType = async props => {
    await postSubmitWarrantyForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitWarrantyForm = createHandlerChainRunner(chain, "SubmitWarrantyForm");
export default submitWarrantyForm;
